import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { scrollToElement } from 'core/utils/helpers/scrollToElement';

import { useDropdown } from 'core/hooks/useDropdown';
import { useToggleMore } from 'core/hooks/useToggleMore';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectProductSearchResultsConfig } from 'core/modules/ProductSearchResults/selectors';

import { triggerPrsApplySortGaEvent } from 'core/modules/ProductSearchResults/actions';

function SortMobile({ productResultsHook }) {
  const dispatch = useDispatch();
  const sortRef = useRef();
  const { fetchSortedProducts, searchParams } = productResultsHook;
  const { sortOptions } = useSelector(selectProductSearchResultsConfig);
  const { toggleSubnav, isFocused } = useDropdown(sortRef);
  const { itemsToShow, renderShowMoreButton } = useToggleMore({ items: sortOptions, limit: 9 });

  const handleOnChange = (sortType) => {
    scrollToElement(document.body, 0);
    fetchSortedProducts(sortType);
    dispatch(triggerPrsApplySortGaEvent(sortType));
  };

  return (
    <div ref={sortRef} className="mn_filter mn_psrMobileFilter">
      <button className="mn_filterTitle" onClick={toggleSubnav} aria-expanded={isFocused}>
        Sort by
      </button>
      { isFocused &&
        <div className="mn_filterDropdown">
          <ul>
            {itemsToShow.map(({ sortBy, viewName }) => (
              <li key={sortBy}>
                <label>
                  <input
                    type="checkbox"
                    onChange={() => handleOnChange(sortBy)}
                    checked={searchParams.sort_by === sortBy}
                  />
                  <span className="mn_name">{viewName}</span>
                </label>
              </li>
            ))}
          </ul>
          {renderShowMoreButton()}
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><SortMobile {...props} /></ComponentErrorBoundary>;
